import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { updateComponentWithObject } from 'src/app/helpers/helpers';
import publicHelpers from 'src/app/helpers/public-helpers';

@Component({
    selector: 'simple-confirmation-dialog',
    template: `
      <div class="dashboard_dialog joi-dialog">
          <div mat-dialog-content>
              <div class="dialog_content">
                <h3 [ngClass]="{warn_text: warning}" >{{ title }}</h3>
                  <div class="para" [innerHTML]="helpers.strWithBreak(description)"></div>
              </div>
          </div>
          <div mat-dialog-actions>
              <button matButton (click)="dialogRef.close()">Cancel</button>
              <button matButton [color]="warning ? 'warn' : 'primary'" (click)="confirm()">{{ confirmText }}</button>
          </div>
      </div>

  `,
    styles: [`
      .dashboard_dialog .para { margin-bottom: 15px; }
      .dashboard_dialog h3 { padding-bottom: 20px; }
      `],
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogModule],
})
export class SimpleConfirmationDialogComponent {

  confirmText = ''
  title = ''
  description = ''
  cancelText = 'Cancel'
  warning = false
  helpers = publicHelpers

  constructor(
    public dialogRef: MatDialogRef<SimpleConfirmationDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData
  ) {
    updateComponentWithObject(this, data)
  }

  confirm() {
    this.dialogRef.close(true)
  }
}

export interface ConfirmationDialogData {
  confirmText: string
  title: string
  description: string
  cancelText?: string
  warning?: boolean
}